<template>
  <div class="flex flex-col gap-1">
    <div
      class="w-full flex items-center gap-2 text-left rounded-md px-2 py-1 transition-colors leading-5"
      :class="selectedId === node.id ? 'bg-gray-100 text-red-700' : 'hover:bg-gray-50 text-gray-700'"
      :style="{ paddingLeft: `${level * 14}px` }"
      @click="$emit('select', node)"
    >
      <span
        class="w-4 h-4 rounded-full border flex-shrink-0 mt-0.5"
        :class="selectedId === node.id ? 'border-red-600' : 'border-gray-300'"
      >
        <span
          v-if="selectedId === node.id"
          class="block w-2 h-2 rounded-full bg-red-600 m-[3px]"
        />
      </span>
      <span class="text-sm leading-5">{{ node.label }}</span>
      <button
        v-if="hasChildren"
        type="button"
        class="ml-auto p-0.5 rounded text-gray-400 hover:text-gray-600"
        @click.stop="$emit('toggle', node.id)"
      >
        <svg
          class="w-4 h-4 transition-transform"
          :class="{ 'rotate-90': expandedMap?.[node.id] }"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>

    <div v-if="hasChildren && expandedMap?.[node.id]" class="flex flex-col gap-1">
      <CatalogFilterMuscTreeNode
        v-for="child in node.items"
        :key="child.id"
        :node="child"
        :level="level + 1"
        :selected-id="selectedId"
        :expanded-map="expandedMap"
        @select="$emit('select', $event)"
        @toggle="$emit('toggle', $event)"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  node: { type: Object, required: true },
  level: { type: Number, default: 0 },
  selectedId: { type: String, default: null },
  expandedMap: { type: Object, default: () => ({}) },
});

defineEmits(["select", "toggle"]);

const hasChildren = computed(() => {
  return Array.isArray(props.node?.items) && props.node.items.length > 0;
});
</script>
